export default "__VITE_ASSET__D33XE1XK__"